import ProductCard from '../components/ProductCard.js';
import '../components/ProductCard.css';
import { projects } from '../assets/projects.js';

const Properties = () =>{

    return(
        <>
        <title>Projects - Faidika Real Estate Limited</title>
        <div className="banner">
          <h2>Our Projects</h2>
        </div>
        <div className="product-grid-container">
            <div className="product-grid">
                {projects.map((product, index) => (
                    <ProductCard key={index} product={product} />
                ))}
            </div>
        </div>

        </>
    );

};

export default Properties;